import { ArrowUpRight } from 'lucide-react';
import { MENU_CATEGORIES, RESTAURANT } from '../constants/restaurant';

export const MenuHighlights = () => {
  return (
    <section
      id="menu"
      data-testid="menu-section"
      className="relative bg-brand-ivory py-24 md:py-36 px-6 md:px-12 lg:px-16"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] font-semibold text-brand-burgundy mb-5">
              Food Highlights
            </p>
            <h2
              data-testid="menu-heading"
              className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-brand-coffee tracking-tight max-w-2xl"
            >
              A menu shaped by{' '}
              <span className="italic text-brand-burgundy">memory</span> and spice.
            </h2>
          </div>
          <a
            href={RESTAURANT.orderUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="menu-view-btn"
            className="group inline-flex items-center gap-3 px-7 py-4 rounded-full bg-brand-coffee text-brand-cream text-xs font-semibold uppercase tracking-[0.22em] hover:bg-brand-burgundy hover:-translate-y-1 transition-all duration-500 shadow-[0_15px_40px_rgba(43,27,23,0.18)] self-start md:self-end"
          >
            View Menu / Order
            <ArrowUpRight className="w-4 h-4 transition-transform group-hover:rotate-45" />
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {MENU_CATEGORIES.map((cat, i) => (
            <MenuCard key={cat.id} cat={cat} feature={i === 0 || i === 5} />
          ))}
        </div>
      </div>
    </section>
  );
};

const MenuCard = ({ cat, feature }) => (
  <a
    href={RESTAURANT.orderUrl}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={`menu-card-${cat.id}`}
    className={`group relative block overflow-hidden rounded-2xl bg-brand-coffee ${
      feature ? 'sm:col-span-2 lg:row-span-1' : ''
    } aspect-[4/5] sm:aspect-[4/5] lg:aspect-[3/4]`}
  >
    <img
      src={cat.img}
      alt={cat.name}
      loading="lazy"
      className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1400ms] group-hover:scale-110"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-brand-coffee/90 via-brand-coffee/30 to-transparent" />
    <div className="absolute inset-x-0 bottom-0 p-5 md:p-6 flex flex-col gap-2">
      <span className="text-[10px] uppercase tracking-[0.3em] text-brand-gold font-bold">
        Speciality
      </span>
      <div className="flex items-end justify-between gap-3">
        <h3 className="font-serif text-2xl md:text-3xl text-brand-cream leading-tight">
          {cat.name}
        </h3>
        <span className="w-10 h-10 rounded-full bg-brand-cream/15 backdrop-blur-md flex items-center justify-center text-brand-cream border border-brand-cream/30 group-hover:bg-brand-gold group-hover:text-brand-coffee group-hover:border-brand-gold transition-all duration-500">
          <ArrowUpRight className="w-4 h-4 transition-transform group-hover:rotate-45" />
        </span>
      </div>
      <p className="text-sm text-brand-cream/75 max-w-[16rem]">{cat.description}</p>
    </div>
  </a>
);

export default MenuHighlights;
